module.exports = __webpack_public_path__ + "static/img/intro.7c90454e.png";